// src/components/CheckEmail.js
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../axiosInstance';
import { Container, Typography, Button, Paper, Stack } from '@mui/material';

const CheckEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // The user’s email was passed via navigate('/check-email', { state: { email } })
  const { email } = location.state || {};

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    if (!email) {
      setMessage("We don't have your email on file.");
      return;
    }

    setLoading(true);
    setMessage('');
    try {
      await axiosInstance.post('/api/auth/resend-confirmation', { email });
      setMessage('A new confirmation email has been sent to your inbox!');
    } catch (error) {
      console.error('Error resending email:', error);
      setMessage(error.response?.data?.message || 'Error resending email. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ marginTop: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Check Your Email
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 2 }}>
          We’ve sent a confirmation link to <strong>{email || 'your email address'}</strong>.
          Please click the link in the email to confirm your account.
        </Typography>

        {message && (
          <Typography variant="body2" color="primary" align="center" paragraph>
            {message}
          </Typography>
        )}

        <Stack direction="row" spacing={2} justifyContent="center">
          <Button variant="outlined" onClick={() => navigate('/')}>
            Home
          </Button>
          <Button 
            variant="contained"
            onClick={handleResend}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Resend Email'}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default CheckEmail;
